"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var animationFrame_1 = require("rxjs/internal/scheduler/animationFrame");
// tslint:disable-next-line
var hoistNonReactStatics = require('hoist-non-react-statics');
/**
 * curried for better type inference
 * @see https://github.com/Microsoft/TypeScript/issues/15005#issuecomment-430588884
 */
exports.withRX = function (Target) { return function (selector, options) {
    if (options === void 0) { options = {}; }
    var scheduler = options.scheduler || animationFrame_1.animationFrame;
    var WithRX = /** @class */ (function (_super) {
        tslib_1.__extends(WithRX, _super);
        function WithRX() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.props$ = new rxjs_1.BehaviorSubject(_this.props);
            _this.selected = selector(_this.props$.asObservable());
            return _this;
        }
        WithRX.prototype.componentDidMount = function () {
            var _a = this.selected, props = _a.props, effects$ = _a.effects$;
            if (props) {
                var inputs = Object.keys(props).map(function (key) {
                    return props[key].pipe(operators_1.map(function (value) {
                        var _a;
                        return (_a = {}, _a[key] = value, _a);
                    }));
                });
                this.inputSubscription = rxjs_1.merge.apply(void 0, inputs).pipe(operators_1.observeOn(scheduler))
                    .subscribe(this.setState.bind(this));
            }
            if (effects$) {
                this.effectsSubscription = effects$.pipe(operators_1.observeOn(scheduler)).subscribe();
            }
        };
        WithRX.prototype.componentWillReceiveProps = function (props) {
            this.props$.next(props);
        };
        WithRX.prototype.componentWillUnmount = function () {
            this.inputSubscription && this.inputSubscription.unsubscribe();
            this.effectsSubscription && this.effectsSubscription.unsubscribe();
        };
        WithRX.prototype.render = function () {
            return react_1.createElement(Target, Object.assign({}, this.selected.defaultProps, this.props, this.state || {}));
        };
        WithRX.displayName = "WithRX(" + (Target.displayName || Target.name) + ")";
        return WithRX;
    }(react_1.PureComponent));
    hoistNonReactStatics(WithRX, Target);
    return WithRX; //defaultProps are tracked by defaultProps argument;
}; };
//# sourceMappingURL=with-rx2.js.map